; (function ($) {
	"use strict";
	$(document).ready(function () {
		$('.query-loop__filter-form select').change(function () {
			$(this).parents('.query-loop__filter-form').trigger('submit')
		})
	});
})(jQuery);
